import { render, staticRenderFns } from "./basicLayout2.vue?vue&type=template&id=1a8b6562&scoped=true"
import script from "./basicLayout2.vue?vue&type=script&lang=js"
export * from "./basicLayout2.vue?vue&type=script&lang=js"
import style0 from "./basicLayout2.vue?vue&type=style&index=0&id=1a8b6562&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a8b6562",
  null
  
)

export default component.exports